import {MutableRefObject, useEffect, useRef} from "react";

type timer = ReturnType<typeof setTimeout>

function usePollingEffect(
    asyncCallback: () => Promise<void>,
    {
        interval = 10_000, // 10 seconds,
        onCleanUp = () => {}
    } = {},
    dependencies: any[] = [],
) {
    const timeoutIdRef: MutableRefObject<timer|null> = useRef(null)
    useEffect(() => {
        let _stopped = false
            // Side note: preceding semicolon needed for IIFEs.
        ;(async function pollingCallback() {
            try {
                await asyncCallback()
            } finally {
                // Set timeout after it finished, unless stopped
                timeoutIdRef.current = !_stopped && setTimeout(
                    pollingCallback,
                    interval
                )
            }
        })()
        // Clean up if dependencies change
        return () => {
            _stopped = true // prevent racing conditions
            clearTimeout(timeoutIdRef.current as timer)
            onCleanUp()
        }
    }, [...dependencies, interval])
}

export default usePollingEffect
